import { pluralizeByUnit } from '@sravni/utils/lib/pluralize';
import { UNIT_TO_METHOD, DURATION, STRING_TO_DURATION } from '../constants/termsAndDuration.js';
import { toTerm } from './toTerm.js';

const getFullUnitCount = (ISODuration, unit) => {
    const method = UNIT_TO_METHOD[toTerm(unit)];
    if (typeof ISODuration === 'string') {
        return method(ISODuration);
    }
    const duration = Object.entries(ISODuration || {}).reduce((acc, [key, value]) => {
        if (Object.values(DURATION).includes(key)) {
            return { ...acc, [key]: value };
        }
        return {
            ...acc,
            [STRING_TO_DURATION[key]]: value,
        };
    }, {});
    return method(duration);
};
const humanize = (ISODuration, unit, options) => {
    const value = getFullUnitCount(ISODuration, unit);
    const { initialForm, termWithUnit = true } = options || {};
    if (!termWithUnit) {
        return `${value}`;
    }
    const unitString = pluralizeByUnit(value, toTerm(unit), { possessive: !initialForm });
    return `${value} ${unitString}`;
};

export { getFullUnitCount, humanize };
//# sourceMappingURL=duration.js.map
